import {
    memo,
    FunctionComponent,
} from 'react';

// Components
import Input from './Input';
import { Dropdown } from 'reactstrap';
import Image from '@Components/Utils/Image';

// Utilities
import classnames from 'classnames';

// Components
import Anchor from '@Components/Utils/Anchor';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';
import { useInputSearch, withInputSearchManager } from '@Components/Layout/Search/Components/InputSearch/Contexts';

import {
    InputSearchProps,
} from '@Components/Layout/Search/Components/InputSearch';

// Styles
import styles from './Style.module.scss';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

interface SearchMobileProps extends InputSearchProps {
    onClickFilter?: () => void;
}

const InputSearchMobile: FunctionComponent<SearchMobileProps> = memo(
    ({ className, showMobile, showFilter, placeholder, onClickFilter, ...props }) => {
        const { deviceType } = useViewDetected();

        const {
            value,
            isEmpty,
            isFocusSearch,
            listHistorySearch,

            handleFocus,
            handleChange,
            handleRemoveValue,
            handleClickSearch,
            handleToggleFocus,
            handleChooseSearch,
            handleDeleteHistory,
        } = useInputSearch();

        const wrapperClassName = classnames([
            styles.wrapper,
            styles.on_top,
            {
                [styles.show_mobile]: showMobile,
                [styles.with_icon_right]: showFilter,
                [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
            },
            className,
        ]);

        const inputSearchMobileClassName = classnames([
            styles.input_wrapper,
            {
                [styles.input_focus]: isFocusSearch && isEmpty && listHistorySearch?.length > 0,
            },
        ]);

        return (
            <form className={wrapperClassName} onSubmit={handleClickSearch}>
                <Dropdown isOpen={isFocusSearch} toggle={handleToggleFocus} className={inputSearchMobileClassName}>
                    <Anchor href="/" className={styles.icon_back_wrapper}>
                        <FontAwesomeIcon className={styles.icon_back} icon={faArrowLeft} />
                    </Anchor>

                    <FontAwesomeIcon className={styles.icon_search} icon={faSearch} />

                    {!isEmpty && (
                        <FontAwesomeIcon
                            icon={faTimesCircle}
                            onClick={handleRemoveValue}
                            className={styles.icon_clear}
                        />
                    )}

                    <Input
                        {...props}
                        type="text"
                        value={value}
                        onFocus={handleFocus}
                        onChange={handleChange}
                        placeholder={placeholder}
                        onChooseSearch={handleChooseSearch}
                        listHistorySearch={listHistorySearch}
                        onDeleteHistory={handleDeleteHistory}
                    />

                    {isFocusSearch && !isEmpty && (
                        <button className={styles.search_value_wrapper} type="submit">
                            <Image className={styles.icon_search_mobile} src="/assets/tra-cuu/search_icon.png" />
                            Xem kết quả cho&nbsp;<span className={styles.value_search}>{value}</span>
                        </button>
                    )}

                    {showFilter && (
                        <Image
                            width={24}
                            height={24}
                            onClick={onClickFilter}
                            className={styles.icon_filter}
                            src="/assets/tra-cuu/filter.png"
                        />
                    )}
                </Dropdown>
            </form>
        );
    },
);

InputSearchMobile.defaultProps = {
    keyword: '',
    className: '',
    showMobile: true,
    showFilter: false,
    onClickFilter: () => null,
};

export default withInputSearchManager(InputSearchMobile);
